import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "table-default"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "buyers-data" }
const _hoisted_5 = { class: "semi-bold text-highlighted" }
const _hoisted_6 = {
  key: 0,
  class: "semi-bold text-highlighted"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "button attention"
}
const _hoisted_10 = {
  key: 2,
  class: "status capitalize"
}
const _hoisted_11 = {
  key: 1,
  class: "no-request-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header" }, "Contract Information Forms", -1)),
    ($setup.eois)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Name"),
              _createElementVNode("th", { class: "column--state" }, "Postcode"),
              _createElementVNode("th", null, "Email"),
              _createElementVNode("th", null, "Buyer Type"),
              _createElementVNode("th", null, "Subject to Finance"),
              _createElementVNode("th", null, "Contact Status"),
              _createElementVNode("th")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.eois.eois, (row, idx) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "cursor-pointer",
                key: idx,
                onClick: ($event: any) => ($setup.onRow(row))
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString($setup.getFirstLastName(row.buyersData?.firstBuyer)), 1),
                    (row.buyersData?.secondBuyer && (row.buyersData?.secondBuyer.firstName || row.buyersData?.secondBuyer.lastName))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.getFirstLastName(row.buyersData?.secondBuyer)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(row.buyersData?.firstBuyer?.postcode? row.buyersData?.firstBuyer?.postcode
: row.buyersData?.firstBuyer?.state), 1),
                _createElementVNode("td", null, _toDisplayString(row.buyersData?.firstBuyer?.email), 1),
                _createElementVNode("td", null, _toDisplayString(row?.buyerType || "-"), 1),
                (row?.contractConditions && $setup.EoiContractConditions.SUBJECT_TO_FINANCE in row?.contractConditions)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["badge", { success: !row.contractConditions?.subjectToFinance }])
                      }, _toDisplayString(row.contractConditions.subjectToFinance ? "Yes" : "No"), 3)
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_8, "-")),
                _createElementVNode("td", null, [
                  _createVNode($setup["ContactStatusBadge"], {
                    contactStatuses: row?.customerDetails?.contactStatuses,
                    estateId: $setup.estateId
                  }, null, 8, ["contactStatuses", "estateId"])
                ]),
                _createElementVNode("td", null, [
                  (row.status === $setup.EoiStatus.PENDING)
                    ? (_openBlock(), _createBlock($setup["LotApproveButton"], {
                        key: 0,
                        lot: $setup.lotInfo(row),
                        disabled: $setup.isApproving,
                        isPaymentAllowed: $setup.isPaymentAllowed,
                        onConfirm: ($event: any) => ($setup.onConfirm($setup.lotInfo(row).eoiId)),
                        onLoading: _cache[0] || (_cache[0] = ($event: any) => ($setup.isApprovLoading = true))
                      }, null, 8, ["lot", "disabled", "isPaymentAllowed", "onConfirm"]))
                    : (row.status === $setup.EoiStatus.WITHDRAWN)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_9, "Withdrawn"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.getLandownerEoiStatus(row.status)), 1))
                ])
              ], 8, _hoisted_3))
            }), 128))
          ]),
          ($setup.openCompletedResForm)
            ? (_openBlock(), _createBlock($setup["CompletedResForm"], {
                key: 0,
                "is-open": $setup.openCompletedResForm,
                onClose: $setup.closeCompletedResForm,
                onShare: _cache[1] || (_cache[1] = ($event: any) => ($setup.openSendEoiDocumentsModal = true)),
                eoiId: $setup.eoiId
              }, null, 8, ["is-open", "eoiId"]))
            : _createCommentVNode("", true),
          ($setup.openSendEoiDocumentsModal)
            ? (_openBlock(), _createBlock($setup["SendEoiDocumentsModal"], {
                key: 1,
                "is-open": $setup.openSendEoiDocumentsModal,
                onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.openSendEoiDocumentsModal = false)),
                eoiId: $setup.eoiId
              }, null, 8, ["is-open", "eoiId"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "no-request" }, "You have no Contract Information Forms for this lot yet", -1)
        ]))]))
  ]))
}